// Centralized API helpers to avoid import.meta.env usage in CRA builds
// NOTE: In CRA, process.env.REACT_APP_* values are replaced at BUILD TIME by webpack.
// Do NOT wrap them in defensive checks like (process && process.env && ...) because
// webpack only replaces the exact string "process.env.REACT_APP_BACKEND_URL".

// This gets replaced at build time by webpack's DefinePlugin
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const NODE_ENV = process.env.NODE_ENV;

export function getApiBase() {
  try {
    // BACKEND_URL is replaced at build time with the actual string value
    if (BACKEND_URL && typeof BACKEND_URL === 'string' && BACKEND_URL.trim()) {
      const trimmed = BACKEND_URL.trim().replace(/\/+$/, '');
      // If it already ends with /api, do not append another /api
      if (/\/api$/i.test(trimmed)) return trimmed;
      return `${trimmed}/api`;
    }

    // Development fallback (only when REACT_APP_BACKEND_URL is not set)
    if (NODE_ENV !== 'production') {
      return 'http://localhost:8001/api';
    }

    // Production without env var - log warning and use empty (will fail gracefully)
    console.error('⚠️ REACT_APP_BACKEND_URL environment variable is not set!');
    return '/api'; // Relative path as last resort
  } catch (e) {
    console.error('Error in getApiBase:', e);
    // Development fallback
    if (NODE_ENV !== 'production') {
      return 'http://localhost:8001/api';
    }
    return '/api';
  }
}

export function getAuthHeaders() {
  const headers = { 'Content-Type': 'application/json' };
  try {
    // Include acting organization header for superadmin org switching
    const actingOrgId = localStorage.getItem('actingOrganizationId');
    if (actingOrgId) {
      headers['X-Acting-Organization-Id'] = actingOrgId;
    }
  } catch (e) {
    // ignore storage errors in restricted contexts
  }
  return headers;
}

// Get the currently acting organization ID (for superadmins)
export function getActingOrganizationId() {
  try {
    return localStorage.getItem('actingOrganizationId');
  } catch (e) {
    return null;
  }
}

// Set the acting organization ID (for superadmins)
export function setActingOrganizationId(orgId) {
  try {
    if (orgId) {
      localStorage.setItem('actingOrganizationId', orgId);
    } else {
      localStorage.removeItem('actingOrganizationId');
    }
  } catch (e) {
    // ignore storage errors
  }
}

// Clear the acting organization ID
export function clearActingOrganizationId() {
  try {
    localStorage.removeItem('actingOrganizationId');
  } catch (e) {
    // ignore storage errors
  }
}